import { Alert, AlertTitle, Stack } from '@mui/material';
import React from 'react';

export default function ErrorToast ({ message, severity }) {
    return (
        <Stack spacing={2}>
            <Alert severity={severity}>
                <AlertTitle>{severity}</AlertTitle>
                {message}
            </Alert>
        </Stack>
    );
}
